import { useTranslation } from "react-i18next";

type ExecutionFailedAlertProps = {
  title?: string;
  description?: string;
  className?: string;
};

export const ExecutionFailedAlert = ({
  title,
  description,
  className = "",
}: ExecutionFailedAlertProps) => {
  const { t } = useTranslation();

  const alertTitle = title ?? t("application_page.execution_failed_title");
  const alertDescription =
    description ?? t("application_page.execution_failed_description");

  return (
    <div
      className={`flex flex-col items-start gap-1 rounded-sm bg-red-light-6 p-3 ${className}`}
      role="alert"
      aria-label={alertTitle}
    >
      <p className="font-body-medium-semibold text-red">{alertTitle}</p>
      <p className="font-body-small-medium text-dark">{alertDescription}</p>
    </div>
  );
};
